{
  "icons": [
    {
      "bx-show": "../../assets/icons/bx-show.svg"
    },
    {
      "bx-show-green": "../../assets/icons/bx-show-green.svg"
    },
    {
      "bx-show-white": "../../assets/icons/bx-show-white.svg"
    },
    {
      "bx-hide-green": "../../assets/icons/bx-hide-green.svg"
    },
    {
      "bx-edit": "../../assets/icons/bx-edit.svg"
    },
    {
      "bx-edit-black": "../../assets/icons/bx-edit-black.svg"
    },
    {
      "bx-search": "../../assets/icons/bx-search.svg"
    },
    {
      "bx-globe-white": "../../assets/icons/bx-globe-white.svg"
    },
    {
      "bx-chart-white": "../../assets/icons/bx-chart-white.svg"
    },
    {
      "bx-cogs-white": "../../assets/icons/bx-cogs-white.svg"
    },
    {
      "bx-task-white": "../../assets/icons/bx-task-white.svg"
    },
    {
      "bx-warn-white": "../../assets/icons/bx-warn-white.svg"
    },
    {
      "bx-user-white": "../../assets/icons/bx-user-white.svg"
    },
    {
      "bx-file-white": "../../assets/icons/bx-file-white.svg"
    },
    {
      "bx-add-white": "../../assets/icons/bx-add-white.svg"
    },
    {
      "bx-menu-white": "../../assets/icons/bx-menu-white.svg"
    },
    {
      "bx-exit-white": "../../assets/icons/bx-exit-white.svg"
    },
    {
      "bx-info-blue": "../../assets/icons/bx-info-blue.svg"
    },
    {
      "bx-download": "../../assets/icons/bx-download.svg"
    },
    {
      "bx-delete": "../../assets/icons/bx-delete.svg"
    },
    {
      "bx-play": "../../assets/icons/bx-play.svg"
    },
    {
      "bx-theme": "../../assets/icons/bx-theme.svg"
    },
    {
      "bx-search-white": "../../assets/icons/bx-search-white.svg"
    },
    {
      "bx-paste": "../../assets/icons/bx-paste.svg"
    },
    {
      "bx-check": "../../assets/icons/bx-check.svg"
    },
    {
      "bx-imports-csv": "../../assets/icons/bx-imports-csv.svg"
    },
    {
      "bx-cancel-reports": "../../assets/icons/bx-cancel.svg"
    },
    {
      "bx-timezone": "../../assets/icons/bx-timezone.svg"
    },
    {
      "bx-pdf": "../../assets/icons/bx-pdf.svg"
    },
    {
      "bx-video": "../../assets/icons/bx-video.svg"
    },
    {
      "bx-fone": "../../assets/icons/bx-fone.svg"
    },
    {
      "bx-email": "../../assets/icons/bx-email.svg"
    },
    {
      "bx-delete-white": "../../assets/icons/bx-delete-white.svg"
    },
    {
      "bx-download-white": "../../assets/icons/bx-download-white.svg"
    },
    {
      "bx-add-service-order": "../../assets/icons/bx-add-service-order.svg"
    },
    {
      "bx-close-service-order": "../../assets/icons/bx-close-service-order.svg"
    }
  ]
}